<template>
    <div>
        <ul>
            <li v-for="item in linkManList" :key="item.phone">
                <Icon class="iconSize" type="ios-contact" />
                <span>{{item.areaName}}</span>
                <span>{{item.title}}</span>
                <span style="margin-left: 20px">{{item.phoneNumber}}</span>
            </li>
        </ul>
       
    </div>
</template>

<script>
export default {
    data(){
        return{
            linkManList:[]
        }
    },
    mounted() {
        this.queryCustomerServers();
    },
    methods: {
        queryCustomerServers() {
            let param = {
                url: 'http://MID-CLIENT-MALL/messageService/websiteService/queryValidCustomerServices',
                body: {}
            }
            this.invoke(param).then(rs => {
                this.linkManList = rs;
            })
        },
    }

}
</script>
<style lang="scss" scoped>
ul {
    width: 100%;
    margin-top: 10px;
    border: 1px solid #eee;
    padding: 20px;

    li {
        height: 35px;
        line-height: 35px;
        .iconSize {
            font-size: 28px;
        }
        span:first-of-type {
            padding: 0 10px 0 10px;
        }
    }
}
dl{
    dd{
        height: 30px;
    }
}
</style>